import { useEffect, useState, useCallback } from "react";
import usePagination from "../usePagination";
import { fetchSingleContentReport } from "../../service/AdminService/courseService";

const useSingleContentReport = (courseId, contentId) => {
  const {
    currentPage,
    pageSize,
    setTotal,
    handlePageChange,
    paginationConfig,
    setCurrentPage,
  } = usePagination();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [title, setTitle] = useState("");

  const fetchData = useCallback(async () => {
    if (!courseId || !contentId) return;

    setLoading(true);
    try {
      const params = {
        page: currentPage,
        size: pageSize,
        searchText: searchText || undefined,
      };

      const res = await fetchSingleContentReport(
        courseId,
        contentId,
        params
      );

      if (res.success) {

        setData(res.data?.content  || []);
        setTotal(res.data?.totalElements || 0);
        setTitle(res.data?.metaDetails.name || "")
      } else {
        setData([]);
        setTotal(0);
      }
    } catch (err) {
      setData([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [courseId, contentId, currentPage, pageSize, searchText, setTotal]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Reset page when searching
  const handleSearch = (value) => {
    setSearchText(value);
    setCurrentPage(0);
  };

  return {
    data,
    loading,
    searchText,
    setSearchText,
    handleSearch,
    paginationConfig,
    handlePageChange,
    title,
  };
};

export default useSingleContentReport;